import * as Sentry from '@sentry/browser'
import config from '../config'

let environment
if (import.meta.env.MODE === 'production') {
  environment = 'production'
  if (config.STAGING) environment = 'staging'
} else {
  environment = 'development'
}

if (import.meta.env.MODE === 'production') {
  Sentry.init({
    dsn: 'https://0f12156430ef495ea4e884acad04b173@sentry.io/1378855',
    environment: environment,
    release: import.meta.env.VITE_SOURCE_VERSION,
    // Errors with messages that contain these strings (or match these regexes) won't be sent to sentry.
    // https://docs.sentry.io/platforms/javascript/configuration/filtering/
    ignoreErrors: [
      'Non-Error exception captured with keys', // Happens when the error is due to a timeout and we didn't ignore it in code
      "Failed to execute 'replaceState' on 'History'", // Happens when people download a Lister page and click a link in it, or something like that
      "Failed to execute 'pushState' on 'History'",
      'Cannot find printer with name',
      'Already listening HID device events', // known issue in the qz-tray library

      // known issue, noisy https://app.asana.com/0/1204859485810598/1206822112036386
      'a raw command',
      'into a raw COMMAND command',
      'as a PDF file'
    ],
    // Avoid sending errors that originate in scripts from certain domains.
    // https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-allowurls-and-denyurls
    denyUrls: [
      /http?s:\/\/js.hs-analytics.net/, // Noise from the Hubspot widget
      /chrome-extension:\/\//,
      /extensions\//,
      /^chrome:\/\//
    ]
  })
}
